import { render, staticRenderFns } from "./SpRatingGraphWidget.vue?vue&type=template&id=4e739f88&"
import script from "./SpRatingGraphWidget.vue?vue&type=script&lang=js&"
export * from "./SpRatingGraphWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports